import React from 'react';
import './InternationalDestinations.css';

const destinations = [
    {
        name: 'Dubai',
        price: '45,000',
        image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&q=80&w=800',
        onclick: () => (window.location.href = '/itinerary/dubai')
    },
    {
        name: 'Singapore',
        price: '52,000',
        image: 'https://www.pelago.com/img/destinations/singapore/1023-1702_singapore2.jpg',
        onclick: () => (window.location.href = '/itinerary/singapore')
    
    },
    {
        name: 'Thailand',
        price: '32,000',
        image: 'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?auto=format&fit=crop&q=80&w=800',
        onclick: () => (window.location.href = '/itinerary/thailand')
    },
    {
        name: 'Bali',
        price: '58,000',
        image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&q=80&w=800',
        onclick: () => (window.location.href = '/itinerary/bali')
    },
    {
        name: 'Vietnam',
        price: '48,000',
        image: 'https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&q=80&w=800'
        ,onclick: () => (window.location.href = '/itinerary/vietnam')
    },
    {
        name: 'Maldives',
        price: '85,000',
        image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?auto=format&fit=crop&q=80&w=800'
        ,onclick: () => (window.location.href = '/itinerary/maldives')
    },
    {
        name: 'Switzerland',
        price: '1,20,000',
        image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&q=80&w=800'
        ,onclick: () => (window.location.href = '/itinerary/switzerland')
    },
    {
        name: 'Paris',
        price: '95,000',
        image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&q=80&w=800'
        ,onclick: () => (window.location.href = '/itinerary/paris')
    },
    {
        name: 'Turkey',
        price: '65,000',
        image: 'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?auto=format&fit=crop&q=80&w=800',
        onclick: () => (window.location.href = '/itinerary/turkey')
    },
    {
        name: 'Australia',
        price: '1,45,000',
        image: 'https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?auto=format&fit=crop&q=80&w=800',
        onclick: () => (window.location.href = '/itinerary/australia')
    
    },
    {
        name: 'Japan',
        price: '1,10,000',
        image: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&q=80&w=800',
        onclick:() =>(window.location.href = '/itinerary/japan')
    },
    {
        name: 'Mauritius',
        price: '72,000',
        image: 'https://images.unsplash.com/photo-1589308078059-be1415eab4c3?auto=format&fit=crop&q=80&w=800',
        onclick: () => (window.location.href = '/itinerary/mauritius')
    }
];

const InternationalDestinations = () => {
    return (
        <section className="int-destinations">
            <div className="id-container">
                <div className="id-header">
                    <span className="id-label">World Exploration</span>
                    <h2 className="id-title">International Holiday Destinations</h2>
                    <p className="id-subtitle">
                        Explore the most iconic cities and breathtaking landscapes across the globe.<br />
                        Our international packages are designed to provide you with a seamless and luxurious global travel experience.
                    </p>
                </div>

                <div className="id-grid">
                    {destinations.map((dest, index) => (
                        <div key={index} onClick={dest.onclick} className="id-card">
                            <div className="id-image-wrapper">
                                <img src={dest.image} alt={dest.name} loading="lazy" />
                                <div className="id-overlay">
                                    <div className="id-info">
                                        <h3 className="id-name">{dest.name}</h3>
                                        <div className="id-price-tag">
                                            <span className="from-text">Starting from</span>
                                            <span className="price-val">Rs.{dest.price}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default InternationalDestinations;
